import type { ReportScreenRow } from './buildReportRows';
import { rangeFileSlug, type ReportRange } from './reportRange';

function csvEscape(value: string): string {
  if (/[",\n]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

/**
 * Design HTML CSV: Screen, Location, Playlist, Uptime %, Hours on air, Plays.
 * Always English, whatever the UI language: the file is read by other tools.
 */
export function downloadReportCsv(rows: ReportScreenRow[], range: ReportRange): void {
  const lines = [
    ['Screen', 'Location', 'Playlist', 'Uptime %', 'Hours on air', 'Plays'],
    ...rows.map((row) => [
      row.name,
      row.location ?? 'Unknown location',
      row.playlist === null ? 'Nothing assigned' : row.playlist || 'Untitled playlist',
      String(row.uptimePct),
      String(row.hoursOnAir),
      String(row.plays),
    ]),
  ];
  const csv = lines.map((line) => line.map((cell) => csvEscape(cell)).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `ghostscreens-report-${rangeFileSlug(range)}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
